import React from "react";
import { motion } from "framer-motion";
import { Check, Rocket } from "lucide-react";
import { PHASE3_CHECKLIST, PHASE1_CHECKLIST } from "../lib/constants";

export const Phase1Details = () => {
    return (
        <section
            id="phase3"
            data-testid="phase3-section"
            className="py-24 sm:py-32 relative bg-[#14110f]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
                    <div className="lg:col-span-5">
                        <div className="font-mono-soft text-xs uppercase tracking-[0.3em] text-pink-brand mb-4">
                            // Where we're at
                        </div>
                        <h2 className="font-display text-5xl sm:text-6xl uppercase leading-[0.9] mb-6">
                            $LBRON <br />
                            <span className="text-yellow-brand">Phase 3</span>
                        </h2>
                        <p className="text-lg text-white/75 leading-relaxed mb-4">
                            Everything we built in Phase 1 & 2 is now coming together.
                        </p>
                        <p className="text-base text-white/60 leading-relaxed mb-4">
                            Stronger push. Wider exposure. Major parts of the project taking shape as we move closer to launch.
                        </p>
                        <p className="text-base text-white/60 leading-relaxed mb-6">
                            Roles for the most active members. A dedicated TG group for marketers, shillers and raiders — focused on one thing: <span className="text-pink-brand font-bold">a bullish launch on Pump.fun.</span>
                        </p>
                        <div className="bg-yellow-brand text-[#0a0806] inline-block px-5 py-3 font-display text-xl uppercase -rotate-1">
                            T-minus launch → cup up
                        </div>
                    </div>

                    <div className="lg:col-span-7 space-y-6">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="border-2 border-pink-brand bg-[#0a0806] p-6 sm:p-8 brutal-shadow-yellow"
                        >
                            <div className="flex items-center justify-between mb-6 pb-4 border-b border-white/10">
                                <span className="font-mono-soft text-xs uppercase tracking-[0.25em] text-[#a19d9a]">
                                    Phase 3 — Expansion
                                </span>
                                <span className="font-mono-soft text-xs uppercase tracking-[0.25em] text-pink-brand">
                                    [ IN PROGRESS ]
                                </span>
                            </div>
                            <ul className="space-y-4" data-testid="phase3-checklist">
                                {PHASE3_CHECKLIST.map((item, i) => (
                                    <motion.li
                                        key={i}
                                        initial={{ opacity: 0, x: -20 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: i * 0.08 }}
                                        data-testid={`checklist-item-${i}`}
                                        className="flex items-start gap-4 group"
                                    >
                                        <div className="mt-0.5 flex-shrink-0 w-7 h-7 bg-pink-brand flex items-center justify-center group-hover:bg-yellow-brand transition-colors">
                                            <Rocket className="w-4 h-4 text-white group-hover:text-[#0a0806]" />
                                        </div>
                                        <span className="text-base sm:text-lg text-white/85">{item}</span>
                                    </motion.li>
                                ))}
                            </ul>
                            <div className="mt-8 pt-5 border-t border-white/10 font-mono-soft text-xs text-[#a19d9a] uppercase tracking-wider">
                                → be active. engage. grow with us.
                            </div>
                        </motion.div>

                        {/* Phase 1 achievements — done */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.15 }}
                            className="border-2 border-yellow-brand/40 bg-[#0a0806]/60 p-5 sm:p-6"
                        >
                            <div className="flex items-center justify-between mb-4 pb-3 border-b border-white/10">
                                <span className="font-mono-soft text-xs uppercase tracking-[0.25em] text-[#a19d9a]">
                                    Phase 1 — Foundation
                                </span>
                                <span className="font-mono-soft text-xs uppercase tracking-[0.25em] text-yellow-brand">
                                    [ ✓ COMPLETE ]
                                </span>
                            </div>
                            <ul className="space-y-2" data-testid="phase1-archive">
                                {PHASE1_CHECKLIST.map((item, i) => (
                                    <li key={i} className="flex items-start gap-3 text-sm text-white/55">
                                        <Check className="w-4 h-4 text-yellow-brand/70 flex-shrink-0 mt-0.5" />
                                        <span className="line-through decoration-white/20">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};
